import { cn } from "@/lib/utils";
import { badgeVariants, getStatusDotColor } from "./BadgeVariants";

/**
 * Badge component with optional status dot indicator
 *
 * @param {string} variant - Badge variant (see badgeVariants.js)
 * @param {string} size - Badge size: "sm" | "default" | "lg"
 * @param {boolean} showDot - Show colored dot indicator (for status badges)
 * @param {string} dotColor - Custom dot color class (overrides auto-detection)
 * @param {string} className - Additional classes
 */
const Badge = ({
  className,
  variant,
  size,
  showDot = false,
  dotColor,
  children,
  ...props
}) => {
  const resolvedDotColor = dotColor || getStatusDotColor(variant);

  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props}>
      {showDot && (
        <span
          className={cn("h-1.5 w-1.5 shrink-0 rounded-full", resolvedDotColor)}
          aria-hidden="true"
        />
      )}
      {children}
    </div>
  );
};

export { Badge };
export default Badge;
